import { Link } from "react-router-dom";
import { MessagesSquare, Share2 } from "lucide-react";
import SocialMessagingCard from "@/components/SocialMessagingCard";

/**
 * Superadmin → Soporte → Redes sociales (5-oct-2026, petición de Luis).
 *
 * Aquí se enlazan el Instagram y la página de Facebook de ReservaManager. Lo
 * que escriban por ahí lo atiende la Carmen de soporte y aparece en
 * Conversaciones, junto al WhatsApp de la plataforma y el chat de ayuda.
 *
 * Es la misma tarjeta que usan los negocios en Integraciones, en modo
 * plataforma: sin complemento y sin sede.
 */
export default function SocialNetworks() {
  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-xl bg-indigo-100 flex items-center justify-center">
          <Share2 className="w-6 h-6 text-indigo-600" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-900">Redes sociales</h1>
          <p className="text-sm text-gray-500">
            El Instagram y la página de Facebook de ReservaManager
          </p>
        </div>
      </div>

      <SocialMessagingCard platform />

      <Link
        to="/admin/soporte"
        className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700"
      >
        <MessagesSquare className="w-4 h-4" />
        Ver las conversaciones de soporte
      </Link>
    </div>
  );
}
